import React from 'react';
import { useFormikContext } from 'formik';

import { Text } from '~/components/core';
import RadioButtonGroupFormik from '~/components/core/Formik/RadioButtonGroupFormik';

import { COMMUNICATIONS_SCOPE_TEXTS } from './texts';

export const EXPOSURE_COMMUNICATIONS_SCOPE_FIELD_ID = 'exposure_communications_scope';

export const EXPOSURE_COMMUNICATIONS_SCOPES = {
  ALL_CLAIM: 'all_claim',
  ASSIGNED_EXPOSURES: 'assigned_exposures',
} as const;

const OPTIONS = [
  {
    text: COMMUNICATIONS_SCOPE_TEXTS.ASSIGNED_EXPOSURES,
    optionValue: EXPOSURE_COMMUNICATIONS_SCOPES.ASSIGNED_EXPOSURES,
  },
  { text: COMMUNICATIONS_SCOPE_TEXTS.ALL_CLAIM, optionValue: EXPOSURE_COMMUNICATIONS_SCOPES.ALL_CLAIM },
];

const CommunicationsScope: React.FC = () => {
  const { isSubmitting } = useFormikContext();

  return (
    <div className="flex flex-col gap-12 pt-16">
      <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.SEMI_BOLD} colorVariant={Text.COLOR_VARIANTS.BLACK}>
        {COMMUNICATIONS_SCOPE_TEXTS.TITLE}
      </Text>
      <Text variant={Text.VARIANTS.XS} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
        {COMMUNICATIONS_SCOPE_TEXTS.NOTE}
      </Text>
      <RadioButtonGroupFormik
        id={EXPOSURE_COMMUNICATIONS_SCOPE_FIELD_ID}
        label=""
        options={OPTIONS}
        withErrorHelper={false}
        viewOnly={isSubmitting}
      />
    </div>
  );
};

export default CommunicationsScope;
